import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { LOGIN_AUTH } from './types';
import { notify } from '../services/notification'

//Role List GET API 

export const RoleNameListAction = (query) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.ROLE_NAMES_LIST + query
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(response => {
    if (response.status === 200) {
      dispatch({ type: types.GET_ROLE_NAME_LIST, payload: response })
      return response
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const RoleNameAction = () => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.ROLE_NAMES
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(response => {
    if (response.status === 200) {
      dispatch({ type: types.GET_ROLE_NAME, payload: response })
      return response
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const ReportNameAction = (id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.REPORT_NAMES + `?exclude_role_id=${id}`
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(response => {
    if (response.status === 200) {
      dispatch({ type: types.GET_REPORTS_NAME, payload: response })
      return response
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}


export const PermissionAction = () => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.PERMISSION
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(response => {
    if (response.status === 200) {
      dispatch({ type: types.PERMISSION_NAME, payload: response })
      return response
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const CreateRoleAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.CREATE_ROLE
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 400) {
      return error.response
    }
  })
}

//Update Role PUT API 
export const UpdateRoleAction = (params = {}, id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.CREATE_ROLE + "/" + id
  let options = Object.assign({ method: 'PUT' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 400) {
      error?.response?.data?.error?.role && notify.error(error?.response?.data?.error?.role)
    } else {
      errorHandler(error)
    }

  })
}